module.exports = __webpack_public_path__ + "img/file_document_sheet.f55eb54c.svg";